import moment from 'moment';
import requestLib from 'superagent';
import FormData from 'form-data';
import { CookieUtil } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

import {
  APIError,
  BadRequestError,
  AuthorizationError,
  AuthenticationError,
} from './errors-api';

const HUBSPOT_FORM_API = 'HUBSPOT_FORM_API';

export const request = async (name, endpoint, method, body, headers = {}) => {
  try {
    const requestObj = requestLib[method.toLowerCase()](`${endpoint}`).set({
      ...(body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' }),
      ...headers,
    });

    const response = await requestObj.send(body);
    return response.body;
  } catch (e) {
    const errorTypeExceptions = {
      BLOCKED_EMAIL: true,
    };

    if (!e || !e.response) {
      throw new Error(e, { cause: e });
    }

    const { response } = e;

    const { body: errBody } = response;
    const obj = {
      name,
      endpoint,
      method,
      body: errBody || {},
      headers,
      response,
    };

    switch (response.status) {
      case 400: {
        const errorException = errBody?.errors?.find(
          error => errorTypeExceptions[error.errorType]
        );

        if (!errorException) throw new BadRequestError(obj);
        return errorException;
      }
      case 403: {
        throw new AuthenticationError(obj);
      }
      case 401: {
        CookieUtil.clearUserAndReload(EnvUtil.cookieDomain);
        throw new AuthorizationError(obj);
      }
      default: {
        throw new APIError(obj);
      }
    }
  }
};

export const createPostBody = ({ fields }, pageName) => {
  const currentTime = moment().valueOf();
  const hutk = CookieUtil.get('hubspotutk') || null;
  // note that the form_submission_time property is added here to allow our hubspot workflow to access
  // a field with a unique id in order to generate a task.
  // The workflow does not have access to submittedAt.
  let formFields = [
    ...fields,
    { name: 'form_submission_time', value: currentTime },
  ];

  // try to get AB Tasty test history and add it as the a_b_tasty_test_exposures property on the form submission
  try {
    const ABTastyTests = window.ABTasty.getCampaignHistory();
    formFields = [
      ...formFields,
      {
        name: 'a_b_tasty_test_exposures',
        value: JSON.stringify(ABTastyTests),
      },
    ];
  } catch {
    /* empty */
  }

  return {
    submittedAt: currentTime,
    fields: formFields,
    context: {
      hutk,
      pageUri: window.location.href,
      pageName,
    },
  };
};

export const postAccessOurNetworkInquireWithAxiom = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotAccessOurNetworkInquireWithAxiom,
    'POST',
    createPostBody(fields, 'Access Our Network')
  );

export const postCreateMqlPassing = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotNewEngagementForm,
    'POST',
    createPostBody(fields, 'Create New MQL')
  );

export const postExternalSearchReachOut = async fields => {
  return request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotExternalSearchReachOut,
    'POST',
    createPostBody(fields, 'Talent Page')
  );
};

export const postDigitalBenchRequestRate = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotDigitalBenchRequestRate,
    'POST',
    createPostBody(fields, 'Digital Bench')
  );

export const postDigitalBenchRequestUpdate = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotDigitalBenchRequestUpdate,
    'POST',
    createPostBody(fields, 'Digital Bench')
  );

export const postDigitalBenchAskUsHow = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotDigitalBenchAskUsHow,
    'POST',
    createPostBody(fields, 'Digital Bench')
  );

export const postAccessOurNetworkConsult = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotAccessOurNetworkConsult,
    'POST',
    createPostBody(fields, 'Access Our Network')
  );

export const postInterstitialDataCollection = async fields =>
  request(
    HUBSPOT_FORM_API,
    EnvUtil.hubspotAltInterstitialFormUrl,
    'POST',
    createPostBody(fields, 'ALT Interstitial')
  );
